// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1mQR6","label":"Category_label__3YkL5","content":"Category_content__1-SdJ","header":"Category_header__1aPp1","location":"Category_location__sNZHa"};